module.exports = __webpack_public_path__ + "media/08. Jasper Byrne - Hotline.037169d5.mp3";